
  // <============ on scrll===========
        const navbar = document.querySelector('.main-header');

        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
        //--------------------------toggle-btn-js------------------------

        $(".navbar-toggler").click(function () {

            $(this).toggleClass('togle');

            $("html").toggleClass("myClass");

        });

// <------ass-seen-carousel------------->

        $(".brands-carousel").slick({
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 5, // fallback
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  centerMode: true,
  focusOnSelect: true,
  responsive: [
   
      {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 1022,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});


// =========== country select========
  //  const selectBox = document.querySelector(".flag-select");
  //   const selected = selectBox.querySelector(".selected-flag img");
  //   const options = selectBox.querySelector(".flag-options");

  //   selectBox.addEventListener("click", () => {
  //     options.style.display = options.style.display === "flex" ? "none" : "flex";
  //   });

  //   options.querySelectorAll("div").forEach(option => {
  //     option.addEventListener("click", () => {
  //       selected.src = option.querySelector("img").src;
  //       options.style.display = "none";
  //     });
  //   });

  //   document.addEventListener("click", (e) => {
  //     if (!e.target.closest(".flag-select")) {
  //       options.style.display = "none";
  //     }
  //   });

    // ============= customer-carousel===============

      $(document).ready(function(){
      $(".customers-carousel").owlCarousel({
        loop:true,
        margin:80,
        nav:true,
        dots:false,
          navText: [
                    "<i class='bi bi-arrow-left'></i>",
                    "<i class='bi bi-arrow-right'></i>"
                ],
        responsive:{
          0:{ items:1 },
          600:{ items:2 },
          1200:{ items:3 }
        }
      });
    });

    // ========= social carousel===========

     $(document).ready(function(){
      $(".instagram-carousel").owlCarousel({
        loop:true,
        margin:15,
        dots:false,
        nav:true,
         navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
        responsive:{
          0:{ items:2 },
          600:{ items:3 },
          1000:{ items:5 }
        }
      });
    });



document.querySelectorAll('.thumbnail-btn').forEach(button => {
  button.addEventListener('click', function () {
    const targetId = this.getAttribute('data-target');

    // Thumbnails: active class switch
    document.querySelectorAll('.thumbnail-btn').forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');

    // Main Images: hide/show
    document.querySelectorAll('.product__media-item').forEach(item => item.classList.add('hidden'));
    document.getElementById(targetId).classList.remove('hidden');
  });
});
